import { configureStore, createListenerMiddleware } from "@reduxjs/toolkit";

import { aiChatSlice } from "./slices/aiChat";
import { authSlice } from "./slices/auth";
import { conceptsSlice } from "./slices/concepts";
import { profileSlice } from "./slices/profile";
import { punttProjectsSlice } from "./slices/punttProjects";
import { ticketSlice } from "./slices/ticket";
import { UISlice } from "./slices/ui";
import { userProfileSlice } from "./slices/userProfile";

import { logout as logoutService } from "../services/auth";

const listenerMiddleware = createListenerMiddleware();

// Runs after the logout reducer: the request reads store.getState(), which
// Redux forbids while a reducer executes (error #3).
listenerMiddleware.startListening({
  actionCreator: authSlice.actions.logout,
  effect: async () => {
    try {
      // Best-effort: clearing the session cookie must never fail the logout.
      await logoutService();
    } catch {
      // Swallowed on purpose; the local session is already gone.
    }
  },
});

export const store = configureStore({
  reducer: {
    aiChat: aiChatSlice.reducer,
    auth: authSlice.reducer,
    concepts: conceptsSlice.reducer,
    profile: profileSlice.reducer,
    punttProjects: punttProjectsSlice.reducer,
    ticket: ticketSlice.reducer,
    ui: UISlice.reducer,
    userProfile: userProfileSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(listenerMiddleware.middleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
